<script>
    import HelpRequest from "./UI/HelpRequest.svelte";
    import ViewFilters from "./UI/ViewFilters.svelte";
    import AlfxAnalysis from "./UI/ALFXAnalysis.svelte";
    import WPNBrowser from "./UI/WPNBrowser.svelte";
    import WPNEdit from "./UI/Edit/WPNEdit.svelte";
    import { createEventDispatcher } from "svelte";
    
    const dispatch = createEventDispatcher();

    /* Modal mode (4 types) & content type:
        create:             content= 'work' or 'assets'
        edit:               content= 'work' or 'assets'
        support:            content=browser or help-request
        view:               content=view-cards
    */

    export let modalMode = "none";
    export let contentType = "none";
    export let selectedItem = null;
</script>

<div class="modal-backdrop" on:click={() => dispatch("cancel")} />
<div class="modal">
    <slot name="wpn-content">
        {#if modalMode == "support"}
            {#if contentType == "browser"}
                <WPNBrowser
                    browserType={modalMode}
                    on:close
                    on:help={() => (contentType = "help-request")}
                />
            {:else if contentType == "help-request"}
                <HelpRequest on:close />
            {/if}
        {:else if modalMode == "analysis"}
            <AlfxAnalysis on:close on:reload_analysis />
        {:else if modalMode == "create"}
            <WPNEdit {selectedItem} createGroup={contentType} on:close />
        {:else if modalMode == "edit"}
            <WPNEdit {selectedItem} on:close />
        {:else if modalMode == "view"}
            <ViewFilters on:close on:save />
        {/if}
    </slot>
</div>

<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: rgba(0, 0, 0, 0.75);
        z-index: 10;
    }

    .modal {
        position: fixed;
        top: 2.5vh;
        left: 2.5%;
        width: 95%;
        height: 95vh;
        background: white;
        padding-top: 0;
        padding-bottom: 0;
        border-radius: 5px;
        z-index: 100;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
        overflow: scroll;
    }
</style>
